export const ErrorMessage = ({message}) => {
  return <p className={'error'}>{message}</p>;
};
